// LandingPage.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Grid,
  useMediaQuery,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import { WhatsApp, Email, Phone, Close } from '@mui/icons-material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { trackContact } from '../utils/supabaseEdgeApi';
import 'swiper/css';
import 'swiper/css/navigation';

const contactActions = [
  {
    label: 'WhatsApp',
    icon: <WhatsApp sx={{ fontSize: 28 }} />,
    href: 'https://wa.me/919986144114?text=Hi%20Vedamarga%20team%2C%20I%20would%20like%20to%20book%20a%20pooja%20and%20need%20guidance.',
    subtitle: '+91 99861 44114',
    target: '_blank',
  },
  {
    label: 'Email',
    icon: <Email sx={{ fontSize: 28 }} />,
    href: 'mailto:vedamarga1@gmail.com?subject=Contact%20Request%20from%20Vedamarga&body=Hello%20Vedamarga%2C%20I%20am%20interested%20in%20your%20services%20and%20would%20like%20more%20information%20about%20booking%20a%20pooja.',
    subtitle: 'vedamarga1@gmail.com',
  },
  {
    label: 'Phone',
    icon: <Phone sx={{ fontSize: 28 }} />,
    href: 'tel:+919986144114',
    subtitle: '+91 99861 44114',
  },
];

// Banner images carousel
const banners = [
  {
    id: 'banner1',
    src: 'https://anleaexwfuafgtwfvfin.supabase.co/storage/v1/object/public/Images/Gemini_Generated_Image_wniy5dwniy5dwniy%20(1).png',
    alt: 'Vedamarga Banner 1'
  }
];

// Sample videos - replace with your actual video URLs
const videos = [
  {
    id: 1,
    title: 'Havana',
    url: 'https://anleaexwfuafgtwfvfin.supabase.co/storage/v1/object/public/Images/WhatsApp%20Video%202026-05-22%20at%205.06.50%20PM.mp4',
    description: 'Glimpse of a traditional Havana ceremony performed by our team'
  },
  {
    id: 2,
    title: 'Mandala',
    url: 'https://anleaexwfuafgtwfvfin.supabase.co/storage/v1/object/public/Images/WhatsApp%20Video%202026-05-22%20at%205.07.01%20PM.mp4',
    description: 'Glimpse of a sacred Mandala drawn by our team'
  },
  {
    id: 3,
    title: 'Kalasha Sthapana',
    url: 'https://anleaexwfuafgtwfvfin.supabase.co/storage/v1/object/public/Images/WhatsApp%20Video%202026-05-22%20at%205.21.21%20PM.mp4',
    description: 'Some mandala and Kalasha Sthapana rituals performed by our team'
  },
  
];

const LandingPage = ({ onBookFeaturedPuja }) => {
  const [showWelcome, setShowWelcome] = useState(true);
  const [featuredPujaOpen, setFeaturedPujaOpen] = useState(true);
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    // Check if user has already seen the welcome banner
    const hasSeenWelcome = localStorage.getItem('vedamarga_welcome_seen');
    if (hasSeenWelcome) {
      setShowWelcome(false);
    } else {
      // Show welcome for 5 seconds, then hide
      const timer = setTimeout(() => {
        setShowWelcome(false);
        localStorage.setItem('vedamarga_welcome_seen', 'true');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem('vedamarga_welcome_seen', 'true');
  };

  return (
    <Box sx={{ width: '100%', background: '#000' }}>
      <Dialog
        open={featuredPujaOpen}
        onClose={() => setFeaturedPujaOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            position: 'relative',
            overflow: 'hidden',
            maxHeight: '92dvh',
            borderRadius: { xs: 3, sm: 4 },
            color: '#fff8e8',
            background: 'linear-gradient(145deg, #4b1018 0%, #741f2a 55%, #321017 100%)',
            boxShadow: '0 24px 80px rgba(0,0,0,0.48)',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -70,
            right: -55,
            width: 190,
            height: 190,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255,205,112,0.28), rgba(255,205,112,0))',
            pointerEvents: 'none',
          }}
        />
        <IconButton
          aria-label="Close featured puja"
          onClick={() => setFeaturedPujaOpen(false)}
          sx={{
            position: 'absolute',
            zIndex: 1,
            top: 10,
            right: 10,
            color: '#fff8e8',
            bgcolor: 'rgba(255,255,255,0.12)',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.22)' },
          }}
        >
          <Close />
        </IconButton>
        <DialogContent
          sx={{
            p: { xs: 2, sm: 4 },
            pt: { xs: 3, sm: 4.5 },
            textAlign: 'center',
            overflowY: 'auto',
          }}
        >
          <Box
            component="img"
            src="https://anleaexwfuafgtwfvfin.supabase.co/storage/v1/object/public/Images/WhatsApp%20Image%202026-05-22%20at%205.21.16%20PM%20(1).jpeg"
            alt="Navaratri puja"
            sx={{
              display: 'block',
              width: '100%',
              maxHeight: { xs: 105, sm: 240 },
              objectFit: 'cover',
              objectPosition: 'center',
              borderRadius: 2.5,
              mb: { xs: 1.5, sm: 2.5 },
            }}
          />
          <Typography
            component="div"
            sx={{
              display: 'inline-flex',
              px: 1.75,
              py: 0.6,
              mb: { xs: 1, sm: 2 },
              border: '1px solid rgba(255,213,137,0.55)',
              borderRadius: 99,
              color: '#ffdc9a',
              fontWeight: 700,
              fontSize: 12,
              letterSpacing: 1.2,
              textTransform: 'uppercase',
            }}
          >
            Upcoming Puja
          </Typography>
          <Typography
            sx={{
              color: '#ffdf9f',
              fontSize: { xs: 26, sm: 38 },
              lineHeight: { xs: 1.1, sm: 1.15 },
              fontWeight: 800,
              mb: { xs: 0.75, sm: 1.25 },
            }}
          >
            Navaratri Puja Parayana
          </Typography>
          <Typography sx={{ color: '#fff3d9', fontSize: { xs: 15, sm: 19 }, fontWeight: 600 }}>
            Starts from 11 October
          </Typography>
          <Typography sx={{ color: 'rgba(255,248,232,0.82)', mt: { xs: 0.5, sm: 1 }, fontSize: { xs: 14, sm: 16 } }}>
            Book now to avoid the last-minute rush
          </Typography>

          <Box
            component="ul"
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: { xs: 0.75, sm: 1 },
              textAlign: 'left',
              listStyle: 'none',
              p: 0,
              my: { xs: 1.5, sm: 3 },
            }}
          >
            {['Ayudha Puja', 'Devi Parayana', 'Durga Puja', 'Navaratri Homa'].map((option) => (
              <Box
                component="li"
                key={option}
                sx={{
                  p: { xs: 0.8, sm: 1.25 },
                  borderRadius: 2,
                  border: '1px solid rgba(255,220,154,0.2)',
                  background: 'rgba(255,255,255,0.07)',
                  color: '#fff8e8',
                  fontWeight: 600,
                  '&::before': {
                    content: '"•"',
                    color: '#ffd587',
                    fontWeight: 900,
                    mr: 1,
                  },
                }}
              >
                {option}
              </Box>
            ))}
          </Box>
          <Box sx={{ display: 'grid', gap: 1 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setFeaturedPujaOpen(false);
                onBookFeaturedPuja?.();
              }}
              sx={{
                minHeight: { xs: 46, sm: 52 },
                borderRadius: 2.5,
                color: '#401017',
                background: 'linear-gradient(90deg, #ffe0a3, #ffc86a)',
                fontWeight: 800,
                fontSize: 16,
                textTransform: 'none',
                boxShadow: '0 8px 24px rgba(0,0,0,0.22)',
                '&:hover': { background: 'linear-gradient(90deg, #ffe9bd, #ffd587)' },
              }}
            >
              Book Pooja Now
            </Button>
            <Button
              fullWidth
              onClick={() => setFeaturedPujaOpen(false)}
              sx={{
                minHeight: 42,
                borderRadius: 2.5,
                color: '#fff8e8',
                border: '1px solid rgba(255,220,154,0.45)',
                fontWeight: 700,
                textTransform: 'none',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
              }}
            >
              Explore more
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Welcome Banner - Shows on first time visit */}
      {showWelcome && (
        <Box
          sx={{
            position: 'relative',
            background: 'linear-gradient(135deg, #d7a47c 0%, #8b6f47 100%)',
            py: 4,
            px: 2,
            textAlign: 'center',
            animation: 'slideDown 0.5s ease-out',
            '@keyframes slideDown': {
              from: {
                transform: 'translateY(-100%)',
                opacity: 0,
              },
              to: {
                transform: 'translateY(0)',
                opacity: 1,
              },
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              cursor: 'pointer',
              color: '#fff',
              '&:hover': {
                transform: 'scale(1.1)',
              },
            }}
            onClick={handleCloseWelcome}
          >
            <Close />
          </Box>
          <Typography sx={{ fontSize: { xs: '24px', sm: '36px' }, fontWeight: 700, color: '#fff', mb: 1 }}>
            🙏 Welcome to Vedamarga 🙏
          </Typography>
          <Typography sx={{ fontSize: { xs: '14px', sm: '18px' }, color: '#fff', mb: 2 }}>
            Your trusted guide to authentic Vedic rituals and spiritual services
          </Typography>
          <Typography sx={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)' }}>
            Experience the wisdom of ancient Vedic traditions
          </Typography>
        </Box>
      )}

      {/* Main Carousel - Banners then Our Sacred Rituals Section */}
      <Box sx={{ mb: 0 }}>
        <Swiper
          modules={[Autoplay, Navigation]}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: true,
          }}
          navigation={!isMobile}
          loop={false}
          slidesPerView={1}
          spaceBetween={0}
          autoHeight
          sx={{
            '& > .swiper-button-next, & > .swiper-button-prev': {
              color: '#d7a47c',
              width: '45px',
              height: '45px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              '&::after': {
                fontSize: '20px',
              },
              '&:hover': {
                background: 'rgba(215,164,124,0.2)',
                borderRadius: '50%',
              },
            },
            '@media (max-width: 600px)': {
              overflow: 'hidden',
              '& > .swiper-wrapper > .swiper-slide': {
                height: 'auto',
              },
              '& > .swiper-wrapper > .swiper-slide > img': {
                maxHeight: '320px',
                objectFit: 'contain',
              },
            },
          }}
        >
          {/* Banner Slides */}
          {banners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <Box
                component="img"
                src={banner.src}
                alt={banner.alt}
                sx={{
                  width: '100%',
                  maxHeight: '500px',
                  objectFit: 'contain',
                  display: 'block',
                  '@media (max-width: 600px)': {
                    maxHeight: '320px',
                  },
                }}
              />
            </SwiperSlide>
          ))}

          {/* Our Sacred Rituals Slide - Stays permanently */}
          <SwiperSlide>
            <Box sx={{ py: 5, px: 2, bgcolor: '#111' }}>
              <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: '28px', sm: '36px' },
                      fontWeight: 700,
                      color: '#d7a47c',
                      mb: 2,
                    }}
                  >
                    Our Sacred Rituals
                  </Typography>
                  <Typography sx={{ color: '#c5c5c5', fontSize: '16px', maxWidth: '600px', mx: 'auto' }}>
                    Watch our team perform authentic Vedic rituals and ceremonies
                  </Typography>
                </Box>

                {/* Video Carousel inside the slide */}
                <Box sx={{ mb: 4 }}>
                  <Swiper
                    modules={[Autoplay, Navigation]}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    navigation={true}
                    slidesPerView={1}
                    spaceBetween={20}
                    breakpoints={{
                      640: {
                        slidesPerView: 2,
                      },
                      1024: {
                        slidesPerView: 3,
                      },
                    }}
                    sx={{
                      '& .swiper-button-next, & .swiper-button-prev': {
                        color: '#d7a47c',
                        '&::after': {
                          fontSize: '20px',
                        },
                      },
                    }}
                  >
                    {videos.map((video) => (
                      <SwiperSlide key={video.id}>
                        <Paper
                          sx={{
                            borderRadius: 2,
                            overflow: 'hidden',
                            bgcolor: '#222',
                            border: '1px solid rgba(215,164,124,0.3)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            '&:hover': {
                              transform: 'translateY(-5px)',
                              boxShadow: '0 10px 30px rgba(215,164,124,0.2)',
                            },
                          }}
                        >
                          {/* Video Embed */}
                          <Box
                            sx={{
                              position: 'relative',
                              paddingBottom: '56.25%',
                              height: 0,
                              overflow: 'hidden',
                            }}
                          >
                            <iframe
                              title={video.title}
                              src={video.url}
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                border: 'none',
                              }}
                              allowFullScreen
                            />
                          </Box>
                          {/* Video Info */}
                          <Box sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                color: '#fff',
                                mb: 1,
                                fontSize: '16px',
                              }}
                            >
                              {video.title}
                            </Typography>
                            <Typography
                              sx={{
                                color: '#c5c5c5',
                                fontSize: '13px',
                                flexGrow: 1,
                              }}
                            >
                              {video.description}
                            </Typography>
                          </Box>
                        </Paper>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>

                {/* (contact actions removed from inside rituals slide - they will be rendered below the main carousel) */}
              </Container>
            </Box>
          </SwiperSlide>
        </Swiper>
      </Box>

      {/* Contact Actions - WhatsApp and other details at bottom of landing page */}
      <Box sx={{ py: 3, px: 2, display: 'flex', justifyContent: 'center', bgcolor: '#000' }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: 980,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {contactActions.map((action) => (
            <Paper
              key={action.label}
              component="a"
              href={action.href}
              onClick={() => trackContact(action.label.toLowerCase() === 'phone' ? 'call' : action.label.toLowerCase())}
              target={action.target || '_self'}
              rel={action.target ? 'noopener noreferrer' : undefined}
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#111',
                border: '1px solid rgba(255,255,255,0.12)',
                color: '#fff',
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                transition: 'transform 0.2s ease, border-color 0.2s ease, background 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  borderColor: '#d7a47c',
                  bgcolor: 'rgba(215,164,124,0.12)',
                },
              }}
              elevation={2}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: 3,
                  display: 'grid',
                  placeItems: 'center',
                  bgcolor: '#191919',
                  color: '#d7a47c',
                }}
              >
                {action.icon}
              </Box>
              <Typography sx={{ fontWeight: 700, display: { xs: 'none', sm: 'block' } }}>{action.label}</Typography>
              <Typography sx={{ color: '#c5c5c5', fontSize: '0.95rem', display: { xs: 'none', sm: 'block' } }}>{action.subtitle}</Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPage;
